import React from 'react';
import {
  InitialResultDto,
  SearchEntityEnum,
  searchEntityTypeList,
  SearchEntityType,
  searchEntityTypeLabel,
  ParamsMap,
  HandlePagingParams,
} from './search-v3-types';

import Box from '@material-ui/core/Box';
import { Loader } from 'components/loader/loader';
import { SearchResult } from '../types';
import Grid from '@material-ui/core/Grid';
import { SearchResultItem } from '../search-result';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const isEmpty = (initialResult: InitialResultDto) => {
  return !Object.keys(initialResult.resultMap).some(
    (key) => initialResult.resultMap[key as SearchEntityType].count > 0
  );
};

export const SearchV3InitalResults = ({
  initialResult,
  loading,
  setLoading,
  setSelectedEntityType,
  handlePaging,
  selectedEntityType,
  pagingResult,
  paramsMap,
  pagingLoading,
}: {
  initialResult?: InitialResultDto | null;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedEntityType: React.Dispatch<React.SetStateAction<SearchEntityEnum>>;
  handlePaging: (args: HandlePagingParams) => Promise<void>;
  selectedEntityType: SearchEntityEnum;
  pagingResult?: SearchResult;
  paramsMap: ParamsMap;
  pagingLoading?: boolean;
}) => {
  if (loading) {
    return (
      <Box mt={4}>
        <Loader />
      </Box>
    );
  }
  if (!initialResult || isEmpty(initialResult)) {
    return null;
  }
  return (
    <>
      {initialResult && (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          width="100%"
          marginTop={4}
        >
          <Tabs
            aria-label="format"
            value={selectedEntityType}
            onChange={async (_, val) => {
              setSelectedEntityType(val as SearchEntityEnum);
              setLoading(true);
              await handlePaging({
                paramsMap,
                selectedEntityType: val as SearchEntityType,
                page: 1,
              });
              setLoading(false);
            }}
          >
            {searchEntityTypeList
              .filter((type) => initialResult.resultMap?.[type]?.count)
              .map((type) => {
                return (
                  <Tab
                    style={{ maxWidth: 300 }}
                    label={
                      <span>
                        {searchEntityTypeLabel[type]}: &nbsp;{' '}
                        <span style={{ marginLeft: 4, fontWeight: 'bold' }}>
                          {initialResult.resultMap?.[type]?.count ?? 0}
                        </span>
                      </span>
                    }
                    value={type}
                  ></Tab>
                );
              })}
          </Tabs>
        </Box>
      )}

      <Grid container spacing={3}>
        {(pagingResult?.items ?? []).map((item, index) => (
          <Grid
            item
            key={item.id}
            xs={12}
            style={{
              margin: '8px 0',
              backgroundColor: '#f6f6f6',
              border: '1px solid #f6f6f6',
              borderRadius: 12,
              opacity: pagingLoading ? 0.5 : 1,
            }}
          >
            <SearchResultItem key={item.label} item={item} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
